class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

updateShipping() {
  fetch(`${routes.cart_url}`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      
      // Update cart drawer content
      const drawerInner = html.querySelector('cart-drawer .drawer__inner');
      if (drawerInner) {
        document.querySelector('cart-drawer .drawer__inner').innerHTML = drawerInner.innerHTML;
      }

      // Update freebies banner
      const freeSampleHeading = html.querySelector('.free__sample__widget .sample .drawer__sample__heading p');
      if (freeSampleHeading) {
        document.querySelector('#CartDrawer .freebies__banner p').innerHTML = freeSampleHeading.innerHTML;
      }

      // Control display of freebies banner
      if (freeSampleHeading) {
        document.querySelector('#CartDrawer .freebies__banner').style.display = "block";
      } else {
        document.querySelector('#CartDrawer .freebies__banner').style.display = "none";
      }

      // Control display of add-to-cart for freebies
      const freebiesAmount = html.querySelector('.free__sample__widget .sample .sample__heading .freebies__amount');
      if (freebiesAmount && freebiesAmount.innerHTML) {
        document.querySelector('#CartDrawer .freebies__banner .freebies__addtocart').style.display = "block";
      } else {
        document.querySelector('#CartDrawer .freebies__banner .freebies__addtocart').style.display = "none";
      }

      // Check for empty cart
      const cartItems = html.querySelectorAll('.cart-items .cart-item');
      if (cartItems.length > 0) {
        document.querySelector('cart-drawer').classList.remove("is-empty");
        if (document.querySelector('cart-items.is-empty')) {
          window.location.reload();
        }
      }

      // Update shipping threshold
      const sourceQty = html.querySelector('#cart-shipping-thresold');
      if (sourceQty) {
        document.querySelector('#CartDrawer .free__delivery__banner').innerHTML = sourceQty.innerHTML;
      }

      // Additional actions if on cart template page
      if (document.querySelector("body.template-cart")) {
        const sc = new CartItems();
        sc.updateShipping();
      }
      
    })
    .catch(e => {
      console.error("Error updating shipping:", e);
    });
}
  
  open(triggeredBy) {
    
    // if(triggeredBy == undefined || closeCartDrawer ) {
    //   let __self = this;
    //   setTimeout(() => {
    //     closeCartDrawer = false;
    //     __self.close();
    //   }, "5000");
    // }
    if (triggeredBy) this.setActiveElement(triggeredBy);
    this.updateShipping();
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    console.log(parsedState);
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));
    
    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
